module.exports = __webpack_public_path__ + "static/media/hackernoon.ab5d2a7e.jpeg";